import { Inject, Injectable, Optional } from '@angular/core'
import { MODAL_MANAGER, ModalManager } from '../../models/modal.model'
import { WarehouseNotification } from './libs/warehouse-notification.lib'
import { WarehouseNotificationOptions } from './warehouse.model'
import { EMPTY, Observable } from 'rxjs'
import {
  NOTIFICATION_MANAGER,
  NotificationManager,
} from '../../models/notification.model'

@Injectable({
  providedIn: 'root',
})
export class WarehousesRepository {
  constructor(
    @Inject(MODAL_MANAGER)
    @Optional()
    private modalManager?: ModalManager,
    @Inject(NOTIFICATION_MANAGER)
    @Optional()
    private notificationManager?: NotificationManager
  ) {}

  /**
   * Show warehouse alert
   * @param options - the warehouse notification or notification options
   * @returns the observable for show the alert about warehouse
   */
  alert$(
    opts: WarehouseNotification | WarehouseNotificationOptions
  ): Observable<boolean> {
    const notification = WarehouseNotification.from(opts)
    return this.modalManager && notification.dialog
      ? this.modalManager.showDialog$(notification.dialog)
      : EMPTY
  }

  /**
   * Notify a message about a packing event
   * @param notification - the packing notification
   */
  notify(opts: WarehouseNotification | WarehouseNotificationOptions): void {
    const notification = WarehouseNotification.from(opts)
    notification.dialog && this.notificationManager?.show(notification.dialog)
  }
}
